import { responsiveMap } from "design-system/src/Components/Grid/_utils/responsiveObserve";
import styled from "styled-components";

export const _DefaultNoticeWrapper = styled.div.attrs({
  className: "default-notice-wrapper",
})`
  position: absolute;
  top: 64px;
  right: 0;
  width: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
  /* Pas de padding-bottom : un enfant absolute ne compte pas dans la hauteur
     du wrapper, l'espacement entre notices reste porté par le gap. */
  padding: 24px 16px 0;

  margin-left: auto;

  /* La notification de suivi de commande est portée en "position: absolute",
     hors du flex de ce wrapper : "top: 100%" la place juste après le
     contenu en flux (ou après le padding-top si elle est seule). Le gap
     avec ce qui précède est fourni par le margin-top de la notice elle-même
     (voir Notification/index.css), pas ajouté ici, pour ne pas le doubler. */
  .rc-notification.rc-notification-bottom-header {
    top: 100%;
  }

  @media (${responsiveMap.md}) {
    min-width: 320px;
    max-width: 480px;

    /* Recale la notification sur le même repère horizontal que le contenu
       en flux (content-box), au lieu de la border-box du wrapper. */
    .rc-notification.rc-notification-bottom-header {
      right: 16px;
    }
  }

  @media (${responsiveMap.mobile}) {
    position: relative;
    max-width: 100%;
    padding: 0;
    margin-left: auto;
    top: 0;
  }
`;
